import _ from 'lodash';
import fs from 'fs-extra';
import readline from 'readline';
import Promise from 'bluebird';
// import through2 from 'through2';
import split2 from 'split2';
import stringify from 'json-stringify-safe';
import path from 'path';
import { Transform } from 'stream';

/*
const isStream = stream =>
  stream !== null &&
  typeof stream === 'object' &&
  typeof stream.pipe === 'function';
*/

// eslint-disable-next-line complexity
export async function read( file, opts={} ) {
  let filter = opts.filter;
  if ( filter && ! _.isFunction( filter ) ) filter = _.iteratee( filter );
  const Model = opts.model;

  const data = [];
  try {
    const text = await fs.readFile( file, { encoding : 'utf8' } );
    let lines = text.split( '\n' );
    if ( opts.reverse ) lines = lines.reverse();
    for ( const line of lines ) {
      if ( line.length === 0 ) continue;
      try {
        const obj = JSON.parse( line );
        if ( ! obj ) continue;
        if ( filter && ! filter( obj ) ) continue;
        if ( Model ) {
          data.push( new Model( obj ) );
        } else {
          data.push( obj );
        }
        if ( opts.limit && data.length === opts.limit ) break;
      } catch( err ) {
        if ( opts.ignoreErrors ) {
          continue;
        } else if ( opts.rawErrors ) {
          data.push( line );
        } else {
          throw err;
        }
      }
    }
  } catch( err ) {
    if ( opts.ignoreErrors ) return [];
  }

  if ( data.length === 1 && opts.array === false ) return data[0];
  return data;
}

export function reader( stream, handler, opts={} ) {
  return new Promise( ( resolve, reject ) => {

    if ( _.isString( stream ) ) stream = getReadStream( stream );
    const conf = {
      input     : stream,
      terminal  : false,
      crlfDelay : Infinity,
    };
    readline.createInterface( conf ).on( 'line', text => {
      try {
        const json = JSON.parse( text );
        handler( json );
      } catch( err ) {
        if ( opts.ignoreErrors ) return;
        if ( opts.onParseError ) return opts.onParseError( err, text );
        reject( err );
        stream.close();
      }
    } ).on( 'close', () => resolve() ).on( 'error', err => reject( err ) );
  } );
}

function getReadStream( file ) {
  return fs.createReadStream( file );
}

function getWriteStream( file ) {
  return fs.createWriteStream( file, {
    flags     : 'a',
    encoding  : 'utf8',
  } );
}

export async function append( file, item ) {
  const stream = getWriteStream( file );
  const { ts, id, ...rest } = item;
  const data = {};
  if ( ts ) data.ts = ts;
  if ( id ) data.id = id;
  _.assign( data, rest );
  const text = stringify( data ) + '\n';
  await fs.ensureDir( path.dirname( file ) );
  return stream.write( text );
}

export function writer( file, opts={} ) {
  // TODO - Need some kind of locking to ensure this isn't being
  // written more than once
  const stream = getWriteStream( file );
  const dmp = dumper( opts );
  dmp.pipe( stream );
  return dmp;
}

export function parser( opts={} ) {
  _.defaults( opts, {
    strict        : true,
    slice         : 50,
  } );

  function parse( line ) {
    if ( ! line ) return;
    try {
      return JSON.parse( line );
    } catch( err ) {
      if ( ! opts.strict ) return;
      let slice = line.slice( 0, opts.slice );
      if ( slice.length < line.length ) slice += '...';
      const error = new Error( 'Could not parse: ' + slice );
      error.cause = err;
      this.emit( 'error', error );
    }
  }

  return split2( parse, opts );
}

export function dumper( opts={} ) {
  const dump = new Transform( { objectMode : true } );
  dump._transform = function _transform( obj, enc, done ) {
    const json = stringify( obj ) + '\n';
    this.push( json );
    done();
  };
  return dump;
}
